import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'ms-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit{
  title = 'ms-cockpit';

  constructor() {
  }

  ngOnInit() {
  }
}
